export const SuggestionsQuestions22 =[
    {
        id:"R22-01",
        category:"一般閱讀題",
        type:'選擇題',
        question: '根據篇章一，杜甫在成都的草堂遭大風吹破屋頂，是哪一年？',
        options:[
            {
                option:'A. 755年',
            },
            {
                option:'B. 761年',
            },
            {
                option:'C. 819年',
            },
            {
                option:'D. 1278年',
            }
        ],
        correctAnswer:'B. 761年',
        explanation: '文中交代761年秋天發生草堂受風雨破壞的事件。',
        score: 1,
        source: '篇章一 草堂遭風雨部分',
        articleIndex: [0],
        // ability_point: '1.1 獲取並提取文本內信息'
    },
    {
        id:"R22-02",
        category:"一般閱讀題",
        type:'選擇題',
        question: '根據篇章二，「博愛之謂仁，行而宜之之謂義」如何解釋「義」？',
        options:[
            {
                option:'A. 追求最多利益',
            },
            {
                option:'B. 避免任何分歧',
            },
            {
                option:'C. 做事合乎道理',
            },
            {
                option:'D. 只依個人喜好行動',
            }
        ],
        correctAnswer:'C. 做事合乎道理',
        explanation: '教材把「行而宜之」解釋為做事合乎道理。',
        score: 1,
        source: '篇章二 原道',
        articleIndex: [1],
        // ability_point: '2.1 建構文本字面意義'
    },
    {
        id:"R22-03",
        category:"一般閱讀題",
        type:'選擇題',
        question: '根據篇章二，韓愈因哪篇奏章被貶潮州？',
        options:[
            {
                option:'A. 〈正氣歌〉',
            },
            {
                option:'B. 〈指南錄後序〉',
            },
            {
                option:'C. 〈原道〉',
            },
            {
                option:'D. 〈論佛骨表〉',
            }
        ],
        correctAnswer:'D. 〈論佛骨表〉',
        explanation: '韓愈上〈論佛骨表〉反對迎佛骨，觸怒皇帝。',
        score: 1,
        source: '篇章二 諫迎佛骨',
        articleIndex: [1],
        // ability_point: '1.1 獲取並提取文本內信息'
    },
    {
        id:"R22-04",
        category:"一般閱讀題",
        type:'選擇題',
        question: '篇章三反覆提到文天祥希望「無愧」，最能反映他以甚麼衡量人生？',
        options:[
            {
                option:'A. 是否守住責任與內心認同的道義',
            },
            {
                option:'B. 是否得到最高官職',
            },
            {
                option:'C. 是否避免所有挫敗',
            },
            {
                option:'D. 是否獲敵方賞識',
            }
        ],
        correctAnswer:'A. 是否守住責任與內心認同的道義',
        explanation: '文中將無愧連繫到國家、百姓、歷史及內心。',
        score: 1,
        source: '篇章三 衣帶贊及結尾',
        articleIndex: [2],
        // ability_point: '2.2 生成推斷'
    },
    {
        id:"R22-05",
        category:"一般閱讀題",
        type:'選擇題',
        question: '三篇文章中的人物雖處境不同，有甚麼共同點？',
        options:[
            {
                option:'A. 都以個人安逸為最高原則',
            },
            {
                option:'B. 都把重視的價值轉化為困境中的選擇',
            },
            {
                option:'C. 都主張放棄生命才能盡責',
            },
            {
                option:'D. 都獲得同樣的政治成果',
            }
        ],
        correctAnswer:'B. 都把重視的價值轉化為困境中的選擇',
        explanation: '杜甫關懷他人、韓愈以行動守道、文天祥守義，均不只停留於口號。',
        score: 1,
        source: '篇章一至三',
        articleIndex: [0,1,2],
        // ability_point: '2.4 整合跨文本信息'
    },
    {
        id:"R22-06",
        category:"一般閱讀題",
        type:'短答題',
        question: '篇章一說杜甫的關懷格外「有重量」，為甚麼？',
        correctAnswer: '他自己的痛苦仍真實存在，並非生活安穩後才談關懷；他在受凍、窮困中仍看見別人的苦難。',
        explanation: '自身困境仍存在（1分）；仍把目光移向他人（1分）。',
        score: 2,
        source: '篇章一 杜甫個人悲哀部分',
        articleIndex: [0],
        // ability_point: '2.2 生成推斷'
    },
    {
        id:"R22-07",
        category:"一般閱讀題",
        type:'短答題',
        question: '根據篇章二，古文運動與韓愈的文化信念有何關係？',
        correctAnswer: '他希望文章不只追求聲律辭藻，而能清楚表達思想、承載值得說的內容，使文化價值透過合宜的語言傳達。',
        explanation: '指出改革文體的方向（1分）；說明內容與思想的要求（1分）；連繫文化責任（1分）。',
        score: 3,
        source: '篇章二 古文運動',
        articleIndex: [1],
        // ability_point: '2.3 整合文本內信息'
    },
    {
        id:"R22-08",
        category:"一般閱讀題",
        type:'短答題',
        question: '篇章三「時窮節乃見」中的「窮」在文中指甚麼？這句話表達甚麼意思？',
        correctAnswer: '窮指走到無路可走、處境極其困難之時；在壓力、失敗和代價面前，人的操守才更清楚地顯現。',
        explanation: '解釋窮（1分）；說明困境顯節（1分）。',
        score: 2,
        source: '篇章三 正氣歌',
        articleIndex: [2],
        // ability_point: '2.1 建構文本字面意義'
    },
    {
        id:"R22-09",
        category:"一般閱讀題",
        type:'短答題',
        question: '杜甫盼望廣廈庇護寒士，文天祥早年忍耐活下來希望救亡。兩者如何顯示個人生命與公共關懷的連繫？',
        correctAnswer: '杜甫由自身受苦想到眾人安居；文天祥珍惜仍可有所作為的生命，希望為國家做事。兩者都把個人處境連繫到他人的福祉或公共責任。',
        explanation: '杜甫內容（1分）；文天祥內容（1分）；共同關係（1分）。',
        score: 3,
        source: '篇章一 廣廈願望；篇章三 將以有為',
        articleIndex: [0,2],
        // ability_point: '2.4 整合跨文本信息'
    },
    {
        id:"R22-10",
        category:"一般閱讀題",
        type:'短答題',
        question: '篇章二引用韓愈被貶途中的詩句，有何作用？請同時從處境和情感說明。',
        correctAnswer: '詩句呈現一日被貶、遠赴潮州的處境，以及風雪阻途、思念家人的蒼涼；也表明他不只惜己，讓守道的代價與決心更具體。',
        explanation: '具體處境（1分）；情感或決心（1分）；說明引文使代價可感（1分）。',
        score: 3,
        source: '篇章二 左遷至藍關示姪孫湘',
        articleIndex: [1],
        // ability_point: '3.2 反思內容與形式'
    },
    {
        id:"R22-11",
        category:"能力點題",
        type:'選擇題',
        question: '根據篇章一，杜甫希望「廣廈千萬間」直接庇護的對象是誰？',
        options: [
            {
                option: 'A. 天下所有官員'
            },
            {
                option: 'B. 自己的親屬'
            },
            {
                option: 'C. 天下寒士'
            },
            {
                option: 'D. 成都商人'
            }
        ],
        correctAnswer: 'C. 天下寒士',
        explanation: '引文為「大庇天下寒士俱歡顏」，教材解作貧寒讀書人。',
        score: 1,
        source: '篇章一 茅屋為秋風所破歌',
        articleIndex: [0],
        ability_point: '1.1 獲取並提取文本內信息'
    },
    {
        id:"R22-12",
        category:"能力點題",
        type:'選擇題',
        question: '根據篇章三，文天祥被俘後拒絕元軍要求他做甚麼？',
        options: [
            {
                option: 'A. 整理自己的詩集'
            },
            {
                option: 'B. 遷居成都'
            },
            {
                option: 'C. 參加科舉'
            },
            {
                option: 'D. 寫信勸南宋將領投降'
            }
        ],
        correctAnswer: 'D. 寫信勸南宋將領投降',
        explanation: '教材交代他拒絕寫勸降書信。',
        score: 1,
        source: '篇章三 被俘與過零丁洋',
        articleIndex: [2],
        ability_point: '1.1 獲取並提取文本內信息'
    },
    {
        id:"R22-13",
        category:"能力點題",
        type:'短答題',
        question: '根據篇章二，寫出與韓愈一同提倡古文的人物，以及古文主要學習哪個時期的散文。',
        correctAnswer: '柳宗元；先秦兩漢散文。',
        explanation: '人物（1分）；時期（1分）。',
        score: 2,
        source: '篇章二 古文運動',
        articleIndex: [1],
        ability_point: '1.1 獲取並提取文本內信息'
    },
    {
        id:"R22-14",
        category:"能力點題",
        type:'短答題',
        question: '根據篇章一末段，列出兩位在被囚時與杜詩產生聯繫的後世人物，並各寫一項相關行動。',
        correctAnswer: '文天祥把杜句重新組合成二百首集杜詩；洪業被日軍囚禁時希望得到一部杜詩。',
        explanation: '兩個姓名各1分；相應行動各1分。',
        score: 4,
        source: '篇章一 末段',
        articleIndex: [0],
        ability_point: '1.1 獲取並提取文本內信息'
    },
    {
        id:"R22-15",
        category:"能力點題",
        type:'選擇題',
        question: '要理解「堅持原則是否代表全盤接受古人的所有觀點」，最適合先讀哪一處？',
        options: [
            {
                option: 'A. 篇章二「今天讀韓愈」的反思段落'
            },
            {
                option: 'B. 篇章一草堂遭風雨的描述'
            },
            {
                option: 'C. 篇章三二十歲中狀元的介紹'
            },
            {
                option: 'D. 篇章一安史之亂的年份'
            }
        ],
        correctAnswer: 'A. 篇章二「今天讀韓愈」的反思段落',
        explanation: '篇章二明言不必完全同意韓愈對佛教的看法。',
        score: 1,
        source: '篇章二 諫迎佛骨後的反思',
        articleIndex: [1],
        ability_point: '1.2 跨來源搜索、導航與篩選'
    },
    {
        id:"R22-16",
        category:"能力點題",
        type:'選擇題',
        question: '要比較韓愈與文天祥如何回應杜甫的文字，哪組資料最直接？',
        options: [
            {
                option: 'A. 只看三篇文章的插圖'
            },
            {
                option: 'B. 工作紙2的〈調張籍〉與〈集杜詩自序〉引文'
            },
            {
                option: 'C. 只看韓愈被貶的路程'
            },
            {
                option: 'D. 只看杜甫建草堂的經過'
            }
        ],
        correctAnswer: 'B. 工作紙2的〈調張籍〉與〈集杜詩自序〉引文',
        explanation: '工作紙並列兩人的閱讀回聲，提供直接比較的證據。',
        score: 1,
        source: '讀者回應工作紙2 任務一',
        articleIndex: [],
        ability_point: '1.2 跨來源搜索、導航與篩選'
    },
    {
        id:"R22-17",
        category:"能力點題",
        type:'短答題',
        question: '你要查找文天祥「先忍耐求生、後拒絕投降」的原因。應從篇章三選取哪兩處資料？各自解答甚麼？',
        correctAnswer: '選〈指南錄後序〉「將以有為」，說明求生是為救亡；選厓山之後及〈衣帶贊〉的段落，說明亡國後以守義、無愧完成生命。',
        explanation: '兩處資料各1分；各自解答的問題各1分。',
        score: 4,
        source: '篇章三 將以有為、厓山之後、衣帶贊',
        articleIndex: [2],
        ability_point: '1.2 跨來源搜索、導航與篩選'
    },
    {
        id:"R22-18",
        category:"能力點題",
        type:'短答題',
        question: '如果要研究「文學怎樣承載公共責任」，請從三篇文章中選兩篇，各指出一項最相關作品及選擇理由。',
        correctAnswer: '可選杜甫〈茅屋為秋風所破歌〉，由自身困苦寫出寒士安居願望；選韓愈〈原道〉或古文運動部分，了解文化思想如何進入文章。也可選文天祥〈正氣歌〉展現困境守節。',
        explanation: '兩篇合適作品／資料各1分；理由各1分。',
        score: 4,
        source: '篇章一至三',
        articleIndex: [0,1,2],
        ability_point: '1.2 跨來源搜索、導航與篩選'
    },
    {
        id:"R22-19",
        category:"能力點題",
        type:'選擇題',
        question: '篇章一「己欲立而立人，己欲達而達人」的意思最接近哪一項？',
        options: [
            {
                option: 'A. 先阻止別人成功以保護自己'
            },
            {
                option: 'B. 只幫助完全相同的人'
            },
            {
                option: 'C. 自己希望成功，也想到及幫助別人實現需要'
            },
            {
                option: 'D. 只有自己成功後才有資格關心別人'
            }
        ],
        correctAnswer: 'C. 自己希望成功，也想到及幫助別人實現需要',
        explanation: '教材把這句連繫到推己及人。',
        score: 1,
        source: '篇章一 開首',
        articleIndex: [0],
        ability_point: '2.1 建構文本字面意義'
    },
    {
        id:"R22-20",
        category:"能力點題",
        type:'選擇題',
        question: '篇章三「將以有為」是文天祥忍耐活下來的理由，意指甚麼？',
        options: [
            {
                option: 'A. 等待別人給他官職'
            },
            {
                option: 'B. 保證所有計劃都成功'
            },
            {
                option: 'C. 認為生命可以換取財富'
            },
            {
                option: 'D. 仍希望為國家做些事情'
            }
        ],
        correctAnswer: 'D. 仍希望為國家做些事情',
        explanation: '教材直接解釋仍有救亡的希望與責任。',
        score: 1,
        source: '篇章三 指南錄後序',
        articleIndex: [2],
        ability_point: '2.1 建構文本字面意義'
    },
    {
        id:"R22-21",
        category:"能力點題",
        type:'短答題',
        question: '根據篇章二，用自己的話解釋「守道」。',
        correctAnswer: '守道是堅持自己相信並認為正確的原則，並願透過行動負責、承擔選擇的後果。',
        explanation: '堅持認同的原則（1分）；行動或承擔（1分）。',
        score: 1,
        source: '篇章二 開首及結尾',
        articleIndex: [1],
        ability_point: '2.1 建構文本字面意義'
        
    },
    {
        id:"R22-22",
        category:"能力點題",
        type:'短答題',
        question: '根據篇章三，解釋「留取丹心照汗青」中「丹心」和「汗青」的意思。',
        correctAnswer: '丹心指忠誠正直的心；汗青指歷史或史冊。整句表達留下忠誠正直之心供歷史記錄。',
        explanation: '丹心（1分）；汗青（1分）。',
        score: 2,
        source: '篇章三 過零丁洋及解說',
        articleIndex: [2],
        ability_point: '2.1 建構文本字面意義'
    },
    {
        id:"R22-23",
        category:"能力點題",
        type:'選擇題',
        question: '杜甫仍會寫疾病、思鄉、窮困，卻也關心天下寒士。可推斷仁者的關懷有甚麼特點？',
        options: [
            {
                option: 'A. 可以與真實的個人悲哀同時存在'
            },
            {
                option: 'B. 必須先消除一切個人感受'
            },
            {
                option: 'C. 代表不再需要住所'
            },
            {
                option: 'D. 只是一種否認現實的方法'
            }
        ],
        correctAnswer: 'A. 可以與真實的個人悲哀同時存在',
        explanation: '教材特別說關心他人沒有使杜甫失去自身悲哀。',
        score: 1,
        source: '篇章一 個人悲哀部分',
        articleIndex: [0],
        ability_point: '2.2 生成推斷'
    },
    {
        id:"R22-24",
        category:"能力點題",
        type:'選擇題',
        question: '韓愈明知進諫可能招致嚴重後果，仍反對迎佛骨。可推斷他把甚麼放在個人安穩之前？',
        options: [
            {
                option: 'A. 文學獎賞'
            },
            {
                option: 'B. 自己認同的文化原則及進諫責任'
            },
            {
                option: 'C. 遊歷潮州的願望'
            },
            {
                option: 'D. 得到所有人的一致支持'
            }
        ],
        correctAnswer: 'B. 自己認同的文化原則及進諫責任',
        explanation: '他願冒風險表達原則，而非只保全晚年。',
        score: 1,
        source: '篇章二 諫迎佛骨及詩句',
        articleIndex: [1],
        ability_point: '2.2 生成推斷'
    },
    {
        id:"R22-25",
        category:"能力點題",
        type:'短答題',
        question: '文天祥說「非情性同哉」，你認為他和杜甫「同」在哪裡？ (提示：可從「經歷」、「關懷」或「價值選擇」其中一方面說明。)',
        correctAnswer: '例如兩人都身處戰亂困境，仍把關懷放到國家與他人。杜甫盼寒士安居，文天祥在被囚中仍守責任，因此能從杜詩找到表達心志的語言。',
        explanation: '指出合理共同點（1分）；杜甫的依據（1分）；文天祥的依據及推論關係（1分）。',
        score: 3,
        source: '讀者回應工作紙2 任務一第1問；篇章一、三',
        articleIndex: [0,2],
        ability_point: '2.2 生成推斷',
        isSuggested: true
    },
    {
        id:"R22-26",
        category:"能力點題",
        type:'短答題',
        question: '文天祥在仍有救亡可能時忍耐活下來，這反映他如何理解生命的價值？請從文本推論。',
        correctAnswer: '他珍惜生命可以承擔責任、有所作為的可能，並不把死亡本身當作目標。「將以有為」顯示求生也可服務於道義。',
        explanation: '合理推論（1分）；準確證據（1分）；連繫生命與責任（1分）。',
        score: 3,
        source: '篇章三 將以有為',
        articleIndex: [2],
        ability_point: '2.2 生成推斷',
    },
    {
        id:"R22-27",
        category:"能力點題",
        type:'選擇題',
        question: '綜合篇章二，哪組內容最完整呈現韓愈如何讓文化信念進入人生？',
        options: [
            {
                option: 'A. 只研究古代字體並收藏書籍'
            },
            {
                option: 'B. 只批評他人的文風'
            },
            {
                option: 'C. 提倡古文、闡明儒家思想、冒險進諫'
            },
            {
                option: 'D. 只寫被貶後的個人感受'
            }
        ],
        correctAnswer: 'C. 提倡古文、闡明儒家思想、冒險進諫',
        explanation: '三個面向分別是文學、思想、政治實踐。',
        score: 1,
        source: '篇章二 全文',
        articleIndex: [1],
        ability_point: '2.3 整合文本內信息'
    },
    {
        id:"R22-28",
        category:"能力點題",
        type:'選擇題',
        question: '綜合篇章一，哪項最完整概括杜甫的仁者之心？',
        options: [
            {
                option: 'A. 有政治抱負，因此從不關心家庭'
            },
            {
                option: 'B. 曾受戰亂，因此只想保全自己'
            },
            {
                option: 'C. 寫詩成功後便沒有痛苦'
            },
            {
                option: 'D. 由真實的自身困苦出發，仍關心他人的安穩'
            }
        ],
        correctAnswer: 'D. 由真實的自身困苦出發，仍關心他人的安穩',
        explanation: '文章同時保留個人困境及推己及人的關懷。',
        score: 1,
        source: '篇章一 全文',
        articleIndex: [0],
        ability_point: '2.3 整合文本內信息'
    },
    {
        id:"R22-29",
        category:"能力點題",
        type:'短答題',
        question: '根據篇章二，概述韓愈所處的文化背景、進諫時面對的取捨、最終選擇，以及一項能說明其精神的作品或詩句。',
        options: [],
        correctAnswer: '背景：佛道盛行、韓愈倡儒。取捨：個人安穩與文化原則。選擇：上〈論佛骨表〉反對迎佛骨、承受被貶。可引「欲為聖明除弊事，肯將衰朽惜殘年」說明不只惜己。',
        explanation: '文化背景（1分）；取捨（1分）；選擇及結果（1分）；作品／引文及其精神連繫（1分）。',
        score: 4,
        source: '讀者回應工作紙1「三個時代，三種取捨」韓愈一列；篇章二',
        articleIndex: [1],
        ability_point: '2.3 整合文本內信息',
        isSuggested: true
    },
    {
        id:"R22-30",
        category:"能力點題",
        type:'短答題',
        question: '綜合篇章三，文天祥在逃亡、被俘及亡國後的不同選擇，如何圍繞同一個核心價值？',
        options: [],
        correctAnswer: '逃亡時忍耐求生，希望救亡；被俘後拒寫勸降信；亡國後拒受官職、堅守道義。選擇雖隨處境改變，都以履責、求無愧為核心。',
        explanation: '三階段準確內容各1分；統整核心價值（1分）。',
        score: 4,
        source: '篇章三 全文',
        articleIndex: [2],
        ability_point: '2.3 整合文本內信息'
    },
    {
        id:"R22-31",
        category:"能力點題",
        type:'選擇題',
        question: '杜甫希望寒士得到庇護，韓愈主張「博愛之謂仁」，兩者有何關係？',
        options: [
            {
                option: 'A. 前者是關愛他人的具體願望，後者以概念說明廣泛愛人'
            },
            {
                option: 'B. 前者否定仁，後者只關心自己'
            },
            {
                option: 'C. 兩者都只討論詩歌格律'
            },
            {
                option: 'D. 兩者要求所有人有相同職業'
            }
        ],
        correctAnswer: 'A. 前者是關愛他人的具體願望，後者以概念說明廣泛愛人',
        explanation: '一為困境中的願望，一為思想定義，皆涉及對他人的關懷。',
        score: 1,
        source: '篇章一 廣廈願望；篇章二 原道',
        articleIndex: [0,1],
        ability_point: '2.4 整合跨文本信息'
    },
    {
        id:"R22-32",
        category:"能力點題",
        type:'選擇題',
        question: '比較韓愈及文天祥，哪一項最能概括兩人的共同取捨？',
        options: [
            {
                option: 'A. 都完全不重視生命'
            },
            {
                option: 'B. 在具體處境中，願為認同的原則承擔代價'
            },
            {
                option: 'C. 都反對任何文化傳承'
            },
            {
                option: 'D. 都因同一場戰爭被俘'
            }
        ],
        correctAnswer: 'B. 在具體處境中，願為認同的原則承擔代價',
        explanation: '共同點在原則與承擔，並不表示處境與觀點完全相同。',
        score: 1,
        source: '篇章二、三',
        articleIndex: [1,2],
        ability_point: '2.4 整合跨文本信息'
    },
    {
        id:"R22-33",
        category:"能力點題",
        type:'短答題',
        question: '如果杜甫是「回聲源」，韓愈和文天祥分別發出了怎樣的「回聲」？ (提示：韓愈的回聲偏向 文學／文章上的；文天祥的回聲偏向 精神／生命上的。請各用一兩句說明。)',
        correctAnswer: '韓愈讚李杜文章「光焰萬丈長」，以「舉頸遙相望」表達文學推崇。文天祥把杜句組成集杜詩，借其語言表達亡國之痛及守義心志，屬精神共鳴。',
        explanation: '韓愈的回聲及引文依據各1分；文天祥的回聲及內容依據各1分。',
        score: 4,
        source: '讀者回應工作紙2 任務一第2問及參考方向',
        articleIndex: [],
        ability_point: '2.4 整合跨文本信息',
        isSuggested: true
    },
    {
        id:"R22-34",
        category:"能力點題",
        type:'短答題',
        question: '杜甫篇章保留他的個人悲哀，韓愈篇章保留他思家的蒼涼。這些內容如何深化我們對「堅持價值」的理解？',
        correctAnswer: '兩人並非沒有個人感受或代價。杜甫受苦仍關懷他人，韓愈思家、受貶仍表達原則，顯示堅持是在真實困難中作出的選擇。',
        explanation: '兩篇具體內容各1分；整合出堅持與真實代價的關係（1分）。',
        score: 3,
        source: '篇章一 個人悲哀；篇章二 藍關詩句',
        articleIndex: [0,1],
        ability_point: '2.4 整合跨文本信息',
    },
    {
        id:"R22-35",
        category:"能力點題",
        type:'選擇題',
        question: '有人引蘇軾「文起八代之衰」，便說「韓愈之前八代所有文章都沒有價值」。哪項評估最恰當？',
        options: [
            {
                option: 'A. 正確，評語可以直接代替逐篇分析'
            },
            {
                option: 'B. 正確，誇張語氣一律等於精確史實'
            },
            {
                option: 'C. 證據不足，頌揚性評語不能證明所有作品皆無價值'
            },
            {
                option: 'D. 不正確，因後人永遠不能評價前人'
            }
        ],
        correctAnswer: 'C. 證據不足，頌揚性評語不能證明所有作品皆無價值',
        explanation: '須辨識評價語氣及證據範圍，避免把概括讀成全稱事實。',
        score: 1,
        source: '篇章二 蘇軾碑文',
        articleIndex: [1],
        ability_point: '3.1 評估質量與真實性'
    },
    {
        id:"R22-36",
        category:"能力點題",
        type:'選擇題',
        question: '若要確認「文天祥寫成二百首集杜詩」的數量及成詩方式，哪一種資料最適合？',
        options: [
            {
                option: 'A. 無署名短片的字幕'
            },
            {
                option: 'B. 只列文天祥姓名的海報'
            },
            {
                option: 'C. 轉載同一句話但沒有出處的網文'
            },
            {
                option: 'D. 附序言、篇目及版本資料的《集杜詩》'
            }
        ],
        correctAnswer: 'D. 附序言、篇目及版本資料的《集杜詩》',
        explanation: '可追溯版本及篇目可核對數量和構成。',
        score: 1,
        source: '篇章一末段；讀者回應工作紙2',
        articleIndex: [0],
        ability_point: '3.1 評估質量與真實性'
    },
    {
        id:"R22-37",
        category:"能力點題",
        type:'短答題',
        question: '有人根據杜甫「安得廣廈千萬間」宣稱他已建成千萬間房屋。請評估此說法，並指出還需要甚麼證據才能證實建屋事實。',
        correctAnswer: '詩句表達願望，不是已完成的工程記錄。若要證實建屋，需要可核對的史料記載、時間地點及實際工程資料，不能只憑詩句。',
        explanation: '辨識願望與事實（1分）；指出推論不足（1分）；提出合適證據（1分）。',
        score: 3,
        source: '篇章一 廣廈願望',
        articleIndex: [0],
        ability_point: '3.1 評估質量與真實性'  
    },
    {
        id:"R22-38",
        category:"能力點題",
        type:'短答題',
        question: '篇章二同時提供韓愈詩句及蘇軾的評語。若用來研究韓愈的選擇，兩種材料各能提供甚麼，又有何限制？',
        correctAnswer: '韓愈詩句可見自我表述與情感，但不能單獨涵蓋事件所有面向；蘇軾評語可見後世評價，但帶有碑文頌揚立場，需配合其他記錄理解。',
        explanation: '每種材料的用途各1分；相應限制各1分。',
        score: 4,
        source: '篇章二 韓愈詩句、蘇軾碑文',
        articleIndex: [1],
        ability_point: '3.1 評估質量與真實性'
    },
    {
        id:"R22-39",
        category:"能力點題",
        type:'選擇題',
        question: '杜甫詩中從漏雨的茅屋寫到「廣廈千萬間」，主要有甚麼表達效果？',
        options: [
            {
                option: 'A. 由個人困境拓展至眾人的安居願望'
            },
            {
                option: 'B. 表明他已搬進新房'
            },
            {
                option: 'C. 說明住所面積的精確變化'
            },
            {
                option: 'D. 把對他人的關懷轉回個人享樂'
            }
        ],
        correctAnswer: 'A. 由個人困境拓展至眾人的安居願望',
        explanation: '空間與關懷範圍同步擴大，突出推己及人。',
        score: 1,
        source: '篇章一 茅屋為秋風所破歌',
        articleIndex: [0],
        ability_point: '3.2 反思內容與形式'
    },
    {
        id:"R22-40",
        category:"能力點題",
        type:'選擇題',
        question: '篇章三先寫文天祥忍耐活下來，再寫他最後守義，主要有甚麼作用？',
        options: [
            {
                option: 'A. 把時間順序刻意倒置'
            },
            {
                option: 'B. 凸顯取義不等於急於赴死，讓最後選擇的代價更清楚'
            },
            {
                option: 'C. 說明他從未希望救國'
            },
            {
                option: 'D. 證明求生與道義必然對立'
            }
        ],
        correctAnswer: 'B. 凸顯取義不等於急於赴死，讓最後選擇的代價更清楚',
        explanation: '敘述先肯定生命與責任，使捨棄生命的選擇有重量。',
        score: 1,
        source: '篇章三 結構',
        articleIndex: [2],
        ability_point: '3.2 反思內容與形式'
    },
    {
        id:"R22-41",
        category:"能力點題",
        type:'短答題',
        question: '三篇標題分別用「仁者之心」「守道」「丹心」概括人物。這些題目如何幫助閱讀？又可能讓讀者忽略甚麼？',
        correctAnswer: '能突出三人的核心精神，方便比較；但若只看標題，可能把人物簡化成單一特質，忽略其個人情感、歷史處境與選擇變化。',
        explanation: '概括與導讀的作用（1分）；可能簡化人物的限制（1分）；舉一項文中被忽略的內容（1分）。',
        score: 3,
        source: '篇章一至三 標題及內容',
        articleIndex: [0,1,2],
        ability_point: '3.2 反思內容與形式'
    },
    {
        id:"R22-42",
        category:"能力點題",
        type:'短答題',
        question: '文天祥把杜甫的詩句重新組合成「集杜詩」，這種形式如何同時表達承繼與新的意義？',
        correctAnswer: '使用杜句保留前人的語言，形成承繼；重新組合使詩句回應文天祥的亡國、囚禁與生命選擇，產生新語境中的意義。',
        explanation: '承繼前人語言（1分）；重新組合及新處境（1分）；說明舊句傳達新意（1分）。',
        score: 3,
        source: '讀者回應工作紙2 集杜詩',
        articleIndex: [],
        ability_point: '3.2 反思內容與形式'
    },
    {
        id:"R22-43",
        category:"能力點題",
        type: '選擇題',
        question:'文天祥早年忍耐求生，後來拒降就義。哪項最能處理兩者表面上的衝突？',
        options: [
            {
                option: 'A. 他前後都只求個人利益'
            },
            {
                option: 'B. 他從來沒有珍惜生命'
            },
            {
                option: 'C. 處境不同，兩種選擇都以履責及守義為準則'
            },
            {
                option: 'D. 凡是選擇改變便代表沒有原則'
            }
        ],
        correctAnswer: 'C. 處境不同，兩種選擇都以履責及守義為準則',
        explanation: '救亡可能及亡國後的責任不同，但核心價值相連。',
        score: 1,
        source: '篇章三 將以有為、厓山之後',
        articleIndex: [2],
        ability_point: '3.3 發現並處理衝突'
    },
    {
        id:"R22-44",
        category:"能力點題",
        type: '選擇題',
        question:'甲欣賞韓愈敢於進諫，乙不同意他的宗教觀點。根據篇章二，怎樣理解二人的意見？',
        options: [
            {
                option: 'A. 乙必須否定韓愈所有成就'
            },
            {
                option: 'B. 甲必須接受韓愈全部主張'
            },
            {
                option: 'C. 兩人不可能同時有道理'
            },
            {
                option: 'D. 可區分承擔勇氣與具體觀點，分別評價'
            }
        ],
        correctAnswer: 'D. 可區分承擔勇氣與具體觀點，分別評價',
        explanation: '教材明言不必全盤同意其佛教觀，仍可思考勇氣與責任。',
        score: 1,
        source: '篇章二 今天讀韓愈',
        articleIndex: [1],
        ability_point: '3.3 發現並處理衝突'
    },
    {
        id:"R22-45",
        category:"能力點題",
        type: '短答題',
        question: '有同學說：「杜甫既然願意讓寒士住廣廈，就不應再抱怨自己的窮困。」請根據篇章一回應這個看法。',
        correctAnswer: '個人痛苦與公共關懷可以並存。文章明說杜甫仍寫疾病、思鄉與窮困，正因自身痛苦真實，他仍關懷他人才更可貴。',
        explanation: '指出兩者可並存（1分）；文本依據（1分）；說明並存如何深化仁心（1分）。',
        score: 3,
        source: '篇章一 個人悲哀部分',
        articleIndex: [0],
        ability_point: '3.3 發現並處理衝突'
    },
    {
        id:"R22-46",
        category:"能力點題",
        type: '短答題',
        question: '甲認為「守道就是永不改變任何看法」，乙認為「只要遇到反對便應放棄原則」。結合篇章二，指出兩者的不足，並提出較合理的理解。',
        correctAnswer: '甲把原則與所有具體看法混為一談，忽略歷史觀點可重新討論；乙把反對當作放棄理由，忽略負責與承擔。可經學習、論證反省具體主張，仍對正當原則負責。',
        explanation: '甲的不足（1分）；乙的不足（1分）；合理理解並連繫教材（1分）。',
        score: 3,
        source: '篇章二 篤信好學、今天讀韓愈、結尾',
        articleIndex: [1],
        ability_point: '3.3 發現並處理衝突'
    },
    {
        id:"R22-47",
        category:"能力點題",
        type: '選擇題',
        question: '你因缺乏電腦而難以完成作業，發現其他同學也有同樣困難。哪項最能遷移杜甫「推己及人」的精神？',
        options: [
            {
                option: 'A. 建議學校提供可預約的共用設備，兼顧大家需要'
            },
            {
                option: 'B. 只要求自己優先使用全部設備'
            },
            {
                option: 'C. 因自己困難便忽略其他人'
            },
            {
                option: 'D. 要求同學停止交作業'
            }
        ],
        correctAnswer: 'A. 建議學校提供可預約的共用設備，兼顧大家需要',
        explanation: '由自身困難理解相近處境，提出共同受益的安排。',
        score: 1,
        source: '篇章一；新增校園情境',
        articleIndex: [0],
        ability_point: '4.1 將理解遷移至新情境'
    },
    {
        id:"R22-48",
        category:"能力點題",
        type: '選擇題',
        question: '小組為爭取獎項準備誇大成果，你認為資料不實。哪項最切合韓愈篇章引出的現代原則？',
        options: [
            {
                option: 'A. 只要能得獎便默許'
            },
            {
                option: 'B. 清楚提出證據與原則，建議修正，並承擔表達意見的責任'
            },
            {
                option: 'C. 不查資料就公開辱罵組員'
            },
            {
                option: 'D. 完全退出討論以免有分歧'
            }
        ],
        correctAnswer: 'B. 清楚提出證據與原則，建議修正，並承擔表達意見的責任',
        explanation: '守道可落實為有根據地發聲及對方案負責。',
        score: 1,
        source: '篇章二；新增合作情境',
        articleIndex: [1],
        ability_point: '4.1 將理解遷移至新情境'
    },
    {
        id:"R22-49",
        category:"能力點題",
        type:'短答題',
        question: '在「看見他人的苦難」「清楚原則」「承擔選擇的代價」三項行事原則中，你認為哪一個最難做到？請結合現實生活中的一個例子，談談為何難以實踐，以及它對面對取捨有甚麼啟示。',
        correctAnswer: '例如最難承擔代價。朋友要求我隱瞞作弊，說真話可能影響友誼，但包庇也傷害公平。我會先勸他主動承認並提供支持，仍不替他說謊，學習以負責方法守住原則。',
        explanation: '選擇原則及具體例子（1分）；分析困難（1分）；準確連繫人物精神（1分）；提出合理啟示／做法（1分）。',
        score: 4,
        source: '讀者回應工作紙3「儒家的取捨」寫一寫',
        articleIndex: [],
        ability_point: '4.1 將理解遷移至新情境',
        isSuggested: true
    },
    {
        id:"R22-50",
        category:"能力點題",
        type:'短答題',
        question: '有同學把文天祥的精神理解為「日常爭執也應冒生命危險證明自己」。請提出較合適的校園應用，並說明與文本的連繫。',
        correctAnswer: '日常可在不實報告或不公平分工前守住誠信，尋求老師協助、提出修正，而非以危險證明決心。文本說取義不等於急於赴死，現代啟示在利益與責任間作出有原則的選擇。',
        explanation: '具體、合宜的校園做法（1分）；指出日常與歷史情境不同（1分）；連繫珍惜生命、守義履責（1分）。',
        score: 3,
        source: '篇章三 將以有為及末段；新增校園情境',
        articleIndex: [2],
        ability_point: '4.1 將理解遷移至新情境'
    },
    {
        id:"R22-51",
        category:"能力點題",
        type:'選擇題',
        question: '為三篇人物故事設計共同展覽主題，哪一項最能統整又傳達當代意義？',
        options: [
            {
                option: 'A. 古人成功，全靠沒有情感'
            },
            {
                option: 'B. 所有困境都有同一個答案'
            },
            {
                option: 'C. 在困境中選擇，把相信的價值活出來'
            },
            {
                option: 'D. 只有當官才可以實踐仁義'
            }
        ],
        correctAnswer: 'C. 在困境中選擇，把相信的價值活出來',
        explanation: '主題保留不同處境與共同的價值實踐。',
        score: 1,
        source: '篇章一至三；新增展覽任務',
        articleIndex: [0,1,2],
        ability_point: '4.2 創造並傳達新意義'
    },
    {
        id:"R22-52",
        category:"能力點題",
        type:'選擇題',
        question: '你要改編杜甫故事成現代短劇，哪個結尾最能保留其精神而不照搬古代情節？',
        options: [
            {
                option: 'A. 主角獲新電腦後忘記其他人的困難'
            },
            {
                option: 'B. 主角只用苦難換取掌聲'
            },
            {
                option: 'C. 主角認為抱怨便能自動改善處境'
            },
            {
                option: 'D. 主角由自己的學習困難想到別人，與同伴建立共用資源'
            }
        ],
        correctAnswer: 'D. 主角由自己的學習困難想到別人，與同伴建立共用資源',
        explanation: '將推己及人轉化為新的具體情境與合作行動。',
        score: 1,
        source: '篇章一；新增短劇任務',
        articleIndex: [0],
        ability_point: '4.2 創造並傳達新意義'
    },
    { 
        id:"R22-53",
        category:"能力點題",
        type:'短答題',
        question: `文天祥說：「凡吾意所欲言者，子美先為代言之。」
你有沒有一句具有儒家精神的句子，也像在替你說話？
請選一句話，可以來自拓展篇章，也可以來自課外。完成下面的「代言卡」。
「凡吾意所欲言者，______先為代言之。」
我選的句子
出處／作者
它體現的儒家精神
我想用這句話應對的情境／問題
我和作者「同」在哪裡`,
        correctAnswer: '示例：杜甫先為代言之。句子「安得廣廈千萬間，大庇天下寒士俱歡顏」，出自杜甫〈茅屋為秋風所破歌〉，體現推己及人。我希望改善缺乏安靜溫習空間的情況，也想到其他同學的同樣需要，與作者都由自身困境關懷眾人。',
        explanation: '句子及作者／出處準確（1分）；儒家精神（1分）；情境具體（1分）；共同點及重新表達的連繫（1分）。課外句子須可核對。',
        score: 4,
        source: '讀者回應工作紙2 任務二「我的跨千年代言人」；按創作表現歸入4.2',
        articleIndex: [],
        ability_point: '4.2 創造並傳達新意義',
        isSuggested: true
    },
    {
        id:"R22-54",
        category:"能力點題",
        type:'短答題',
        question: '寫一段50至80字的校園短劇結尾，把韓愈「清楚原則」和杜甫「看見他人的苦難」結合。須包含一項取捨及一個可實行的行動。',
        correctAnswer: '組員想誇大義賣成果來得獎。小晴說：「幫人不能靠假數字。」她也想到受助同學的需要，提議如實提交報告，再舉辦一次小型義賣。大家放下得獎的捷徑，一起把支援做好。',
        explanation: '兩種精神各1分；取捨與具體行動（1分）；故事連貫且字數大致符合（1分）。',
        score: 4,
        source: '篇章一、二；新增創作任務',
        articleIndex: [0,1],
        ability_point: '4.2 創造並傳達新意義'
    }
]